<template>
  <div>
    <v-dialog
      :value="true"
      persistent
      width="500"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          v-if="editcontact.id"
          dense
          dark
        >
          Editing Contact
          <v-spacer/>
        </v-toolbar>
        <v-toolbar
          v-else
          dense
          dark
        >
          New Contact
          <v-spacer/>
        </v-toolbar>
        <v-card-text>
          <v-form ref="editForm">
            <v-container fluid>
              <v-layout
                row
                wrap
              >
              <v-flex xs4>
                <v-text-field
                  v-model="editcontact.last_name"
                  :error-messages="errorMessages['last_name']"
                  :rules="[v => !!v || 'Last Name is required']"
                  autofocus
                  label="Last Name"
                  v-on:keyup.enter="save()"
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="editcontact.first_name"
                  label="First Name"
                  v-on:keyup.enter="save()"
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="editcontact.middle_name"
                  label="Middle Name"
                  v-on:keyup.enter="save()"
                />
              </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
              <v-flex
                xs6
              >
                <v-text-field
                  v-model="editcontact.email"
                  :error-messages="errorMessages['email']"
                  :rules="editcontact.email ? [v => /.+@.+/.test(v) || 'E-mail must be valid'] : []"
                  :hide-details="!editcontact.email"
                  label="E-mail"
                  v-on:keyup.enter="save()"
                />
              </v-flex>
              <v-flex
                xs6
              >
                <v-text-field
                  v-model="editcontact.phone"
                  :error-messages="errorMessages['phone']"
                  :rules="editcontact.phone ? [v => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v) || 'Phone Number must match ###-###-####, ##########, ### ### #### or any equivalent format'] : []"
                  :hide-details="!editcontact.phone"
                  label="Cell Number"
                  v-on:keyup.enter="save()"
                />
              </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
              <v-flex>
                <v-text-field
                  v-model="editcontact.cuid"
                  :error-messages="errorMessages['cuid']"
                  hide-details
                  label="Contact Unique Identifier"
                  v-on:keyup.enter="save()"
                />
              </v-flex>
              </v-layout>
            </v-container>
            <div
              v-if="editcontact.id"
            >
              <hr />
              <div style="padding: 20px;">Notification Settings: </div>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-switch
                    v-model="editcontact.notify_by_email"
                    style="display:inline;text-align:center;"
                    label="Via E-mail"
                    :disabled="!editcontact.email"
                    :hint="editcontact.email"
                    persistent-hint
                  ></v-switch>
                </v-flex>
                <v-flex
                  v-if="domainInfo.text_enabled"
                  xs6
                >
                  <v-switch
                    v-model="editcontact.notify_by_phone"
                    style="display:inline;"
                    label="Via SMS"
                    :disabled="!editcontact.phone"
                    :hint="editcontact.phone"
                    persistent-hint
                  ></v-switch>
                </v-flex>
                <v-flex
                  xs12
                >
                  <br/>
                  <v-btn
                    @click.prevent="resetDemoState"
                    :disabled="!editcontact.tutorial_date"
                  >
                    Reset Demo State
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="saving"
            flat
            color="gray"
            @click="$emit('cancel')"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="saving"
            flat
            color="blue"
            @click="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog
        :value="showSuccessDialog"
        persistent
        width="300"
      >
        <v-card>
          <v-card-text>
            <span>Successfully reset contacts demo state</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="showSuccessDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactDialog',
  props: [ 'value' ],
  data () {
    return {
      saving: false,
      editcontact: JSON.parse(JSON.stringify(this.value || {})),
      errorMessages: [],
      domainInfo: {},
      showSuccessDialog: false
    }
  },
  created () {
    this.domainInfo = this.getDomainInfo
  },
  computed: {
    ...mapGetters('auth', [
      'getDomainInfo',
    ]),
  },
  methods: {
    save () {
      if (this.$refs.editForm.validate()) {
        this.saving = true
        this.errorMessages = []
        if (!this.editcontact.tags) {
          this.editcontact.tags = []
        }
        api.userform.contact.save(this.editcontact, [400])
          .then(contact => {
            this.saving = false
            this.$emit('input', contact)
          })
          .catch(error => {
            this.saving = false
            if (error.response.status === 400) {
              this.errorMessages = JSON.parse(error.request.response)
            }
          })
      }
    },
    resetDemoState () {
      api.userform.contact.resetDemoState(this.editcontact)
        .then(response => {
          if(response.data.reset) {
            this.editcontact.tutorial_date = null
            this.showSuccessDialog = true
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.errorMessages = JSON.parse(error.request.response)
          }
        })
    }
  }
}
</script>
